import type { UserType } from "@/models"
import { httpRequestJsonResponse, RequestMethod } from "./httpService"

export const listUserTypes = async () => await httpRequestJsonResponse<UserType[]>("/api/user-types", RequestMethod.GET)
